import type React from "react";
import { useState } from "react";
import type { ButtonType } from "@similarweb/ui-components";
import { IconButton, Button } from "@similarweb/ui-components";
import type { IconName } from "@similarweb/icons";

interface IButton {
    text: string;
    onClick: () => void;
    type: ButtonType;
    icon?: IconName;
}

interface IButtonsList {
    buttons: IButton[];
}

export const ButtonsList: React.FC<IButtonsList> = ({ buttons }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getCommonProps = (button: IButton, index: number) => ({
        key: index,
        type: button.type,
        height: "36px",
        isLoading: isLoading,
        onClick: () => {
            setIsLoading(true);
            button.onClick();
        },
    });

    return (
        <>
            {buttons.map((button, index) => {
                return button.icon ? (
                    <IconButton
                        {...getCommonProps(button, index)}
                        iconName={button.icon}
                    >
                        {button.text}
                    </IconButton>
                ) : (
                    <Button {...getCommonProps(button, index)}>{button.text}</Button>
                );
            })}
        </>
    );
};
